<template>
    <div class="MMyCourse">
        <MMyQuestion></MMyQuestion>
    </div>
</template>

<script>
    import MMyQuestion from 'views/mobile/my/course/components/MMyQuestion'
    export default {
        name: 'MMyQueBank',
        data() {
            return {
                active: 0,
            }
        },
        mounted() {},
        activated() {},
        methods: {},
        filters: {},
        watch: {},
        computed: {},
        components: {
            MMyQuestion
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .MMyCourse {
        .van-tabs__wrap {
            border-bottom: 0.01rem solid #E5E5E5;
        }
        .van-tabs__nav--line {
            padding-bottom: 0.16rem;
        }
    }
</style>